// StateLine (job page round 2, Amir 26 Oct: "make the job's state and the next thing that happens
// obvious"): where a record stands, in two lines. The first: its state in one bold word, then what's
// happening now. The second: "Next" and what happens next, in words, with the date and who. No mark
// beside the word: a small drawn box read as a checkbox; the word carries the state. A problem is the
// one red thing in it, and is a link to where it's fixed ("3 things to clear"); money owing is bold.
// Nothing after Next when nothing is left to do. Reads only --stline-*.
import type { ReactNode } from 'react';
import './StateLine.css';

export interface StateLineProps {
  /** The state in one word or two: "Booked", "Waiting for review"; none when only `now` has news. */
  word?: string;
  /** What's happening now: "nobody has been out yet". */
  now?: ReactNode;
  /** What happens next: "Visit 1, Mon Oct 26, 8 a.m.–4 p.m. with Sam and Lee". None when it's over. */
  next?: ReactNode;
  /** The second line's label ("Next"). */
  nextLabel?: string;
  /** For screen readers, the whole ("Where the job stands"). */
  label?: string;
}

export function StateLine({
  word,
  now,
  next,
  nextLabel = 'Next',
  label = 'Where it stands',
}: StateLineProps) {
  return (
    <div className="fl-stline" role="group" aria-label={label}>
      <div className="fl-stline__grid">
        <p className="fl-stline__row">
          {word ? <b className="fl-stline__word">{word}</b> : null}
          {now ? <span className="fl-stline__now">{now}</span> : null}
        </p>
        {next ? (
          <p className="fl-stline__row">
            <span className="fl-stline__label">{nextLabel}</span>
            <span className="fl-stline__next">{next}</span>
          </p>
        ) : null}
      </div>
    </div>
  );
}

/** A problem inside the line: red words (a Link with variant danger, when it goes somewhere). */
export function StateProblem({ children }: { children: ReactNode }) {
  return <span className="fl-stline__bad">{children}</span>;
}
/** Money owing inside the line: bold. */
export function StateStrong({ children }: { children: ReactNode }) {
  return <b className="fl-stline__strong">{children}</b>;
}
